import { Button, Tag, TagPicker } from 'rsuite';
import CustomPopover from './CustomPopover';
import React, { Dispatch, SetStateAction } from 'react';
import * as requestsApi from '../api/requests';
import * as studentsApi from '../api/students';

type ItemDataType = {
  label: string;
  value: string | number;
  [key: string]: any;
};

type Props = {
  requestsFilter?: (requests: any[]) => any[];
  studentsFilter?: (students: any[]) => any[];
  requestsList: {
    id: any;
    email: any;
    firstName: string;
    secondName: string;
  }[];
  studentsList: {
    id: any;
    email: any;
    firstName: string;
    secondName: string;
  }[];
  setRequestsList: Dispatch<
    SetStateAction<
      {
        id: any;
        email: any;
        firstName: string;
        secondName: string;
      }[]
    >
  >;
  setStudentsList: Dispatch<
    SetStateAction<
      {
        id: any;
        email: any;
        firstName: string;
        secondName: string;
      }[]
    >
  >;
  initialRequestsList?: any[];
  initialStudentsList?: any[];
};

export default function RequestsAndStudentsSearcher({
  requestsList,
  studentsList,
  setRequestsList,
  setStudentsList,
  initialRequestsList = [],
  initialStudentsList = [],
  requestsFilter = param => param,
  studentsFilter = param => param,
}: Props) {
  const [foundRequests, setFoundRequests] =
    React.useState<any[]>(initialRequestsList);
  const [foundStudents, setFoundStudents] =
    React.useState<any[]>(initialStudentsList);
  const [requestsLoading, setRequestsLoading] = React.useState<boolean>(false);
  const [studentsLoading, setStudentsLoading] = React.useState<boolean>(false);
  let requestsSearchTimeout: any;
  let studentsSearchTimeout: any;

  const getRequests = async (searchKeyword?: string) => {
    setRequestsLoading(true);
    const requests = await requestsApi.list(
      1,
      20,
      searchKeyword,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined
    );
    setFoundRequests(requestsFilter(requests.data));
    setRequestsLoading(false);
  };

  const getStudents = async (searchKeyword?: string) => {
    setStudentsLoading(true);
    const students = await studentsApi.list(
      1,
      20,
      searchKeyword,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined
    );
    setFoundStudents(studentsFilter(students.data));
    setStudentsLoading(false);
  };

  const setRequestsSearchTimeout = (
    searchKeyword?: string,
    timeout: number = 500
  ) => {
    if (requestsSearchTimeout) {
      clearTimeout(requestsSearchTimeout);
    }
    requestsSearchTimeout = setTimeout(() => {
      getRequests(searchKeyword).catch(console.error);
    }, timeout);
  };

  const setStudentsSearchTimeout = (
    searchKeyword?: string,
    timeout: number = 500
  ) => {
    if (studentsSearchTimeout) {
      clearTimeout(studentsSearchTimeout);
    }
    studentsSearchTimeout = setTimeout(() => {
      getStudents(searchKeyword).catch(console.error);
    }, timeout);
  };

  return (
    <>
      <div>
        <label>Анкети (пошта)</label>
        <br />
        <TagPicker
          style={{ width: 280, margin: 8 }}
          data={foundRequests.map(r => ({
            label: r.email,
            value: r.id,
            firstName: r.firstName,
            secondName: r.secondName,
          }))}
          loading={requestsLoading}
          value={requestsList.map(r => r.id)}
          onSelect={(value, item, event) => {
            if (requestsList.find(i => i.id === item.value)) {
              setRequestsList(requestsList.filter(i => i.id !== item.value));
            } else {
              setRequestsList([
                ...requestsList,
                {
                  id: item.value,
                  email: item.label,
                  firstName: item.firstName,
                  secondName: item.secondName,
                },
              ]);
            }
          }}
          renderOption={(label, item) => {
            return (
              <CustomPopover
                trigger="hover"
                placement="rightEnd"
                controlId={`control-id-${item.value}`}
                speakerContent={<p>{`${item.firstName} ${item.secondName}`}</p>}
              >
                <p>{label}</p>
              </CustomPopover>
            );
          }}
          renderValue={(values: any, items: any, selectedElement: any) => {
            return (items as ItemDataType[]).map(item => (
              <CustomPopover
                trigger="hover"
                placement="right"
                controlId={`control-id-${item.value}`}
                speakerContent={
                  <p>{`${requestsList
                    .filter(r => r.id === item.value)
                    .map(r => `${r.firstName} ${r.secondName}`)
                    .join(',')}`}</p>
                }
              >
                <Tag key={item.value}>{item.label}</Tag>
              </CustomPopover>
            ));
          }}
          onClean={() => {
            setRequestsList([]);
          }}
          onTagRemove={(value, event) => {
            setRequestsList(requestsList.filter(r => r.id !== value));
          }}
          onSearch={searchKeyword => setRequestsSearchTimeout(searchKeyword)}
        />
      </div>
      <div>
        <label>Студенти (пошта)</label>
        <br />
        <TagPicker
          style={{ width: 280, margin: 8 }}
          data={foundStudents.map(s => ({
            label: s.email,
            value: s.id,
            firstName: s.firstName,
            secondName: s.secondName,
          }))}
          loading={studentsLoading}
          value={studentsList.map(s => s.id)}
          onSelect={(value, item, event) => {
            if (studentsList.find(i => i.id === item.value)) {
              setStudentsList(studentsList.filter(i => i.id !== item.value));
            } else {
              setStudentsList([
                ...studentsList,
                {
                  id: item.value,
                  email: item.label,
                  firstName: item.firstName,
                  secondName: item.secondName,
                },
              ]);
            }
          }}
          renderOption={(label, item) => {
            return (
              <CustomPopover
                trigger="hover"
                placement="rightEnd"
                controlId={`stud-control-id-${item.value}`}
                speakerContent={<p>{`${item.firstName} ${item.secondName}`}</p>}
              >
                <p>{label}</p>
              </CustomPopover>
            );
          }}
          renderValue={(values: any, items: any, selectedElement: any) => {
            return (items as ItemDataType[]).map(item => (
              <CustomPopover
                trigger="hover"
                placement="right"
                controlId={`stud-control-id-${item.value}`}
                speakerContent={
                  <p>{`${studentsList
                    .filter(s => s.id === item.value)
                    .map(r => `${r.firstName} ${r.secondName}`)
                    .join(',')}`}</p>
                }
              >
                <Tag key={item.value}>{item.label}</Tag>
              </CustomPopover>
            ));
          }}
          onClean={() => {
            setStudentsList([]);
          }}
          onTagRemove={(value, event) => {
            setStudentsList(studentsList.filter(s => s.id !== value));
          }}
          onSearch={searchKeyword => setStudentsSearchTimeout(searchKeyword)}
        />
      </div>
    </>
  );
}
